<template>
  <BoxCard class="mt-10">
    <template #header>About the clinic</template>
    <template #content>
      <div
        class="prose prose-sm prose-vice"
        v-html="this.$page.props.session.about.about_the_clinic"
        v-if="checkIfHasContent(this.$page.props.session.about?.about_the_clinic)"
      ></div>
      <div class="prose prose-sm prose-vice" v-else>
        <span class="text-gray-500 italic">No description</span>
      </div>
    </template>
  </BoxCard>
</template>

<script>
import BoxCard from '@/Components/Cards/BoxCard.vue';

export default {
  name: 'AboutClinic',
  components: {
    BoxCard,
  },
  methods: {
    checkIfHasContent(content) {
      if (content) {
        return Boolean(content.replace(/<\/?[^>]+(>|$)/g, ''));
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
